/* eslint-disable import/no-anonymous-default-export */
import styled from "styled-components";
import { ActionsStyleTypes } from "./TableActions.type";

const ActionContainer = styled.div.attrs<ActionsStyleTypes>((props) => ({
  className: `${
    props.type === "View"
      ? "hover:text-green-400 hover:bg-green-400"
      : props.type === "Edit"
      ? "hover:text-amber-300 hover:bg-amber-300"
      : props.type === "Delete"
      ? "hover:text-red-500 hover:bg-red-500"
      : props.type === "Add"
      ? "hover:text-blue-500 hover:bg-blue-500"
      : props.type === "Download"
      ? "hover:text-purple-500 hover:bg-purple-500"
      : ""
  } 
  w-8 h-8 rounded bg-gray-100 cursor-pointer flex justify-center text-neutral-400 items-center hover:bg-opacity-10 `,
}))<ActionsStyleTypes>``;

export default {
  ActionContainer,
};
